import React, { useEffect, useState } from 'react';
import { I18n } from 'react-redux-i18n';

import { formatAge } from '../../helpers/formatAge';

export interface AgeDisplayProps {
  timestamp: string;
  refreshIntervalMs?: number;
  testId?: string;
}

export function AgeDisplay({
  timestamp,
  refreshIntervalMs = 60_000,
  testId,
}: AgeDisplayProps): React.ReactElement {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (refreshIntervalMs <= 0) return undefined;
    const id = window.setInterval(() => setNow(Date.now()), refreshIntervalMs);
    return () => window.clearInterval(id);
  }, [refreshIntervalMs]);

  const age = formatAge(timestamp, now);
  return (
    <span data-testid={testId} data-unit={age.unit}>
      {I18n.t(age.i18nKey, { value: age.value })}
    </span>
  );
}

export default AgeDisplay;
